module.exports = __webpack_public_path__ + "static/media/NotoSansThai-Bold.eaaaa173.ttf";